import type { AppUser } from "../../../shared/models/user";
import { createDataStore } from "../lib/data_store";
import { get, post } from "aws-amplify/api";
import { API_NAME } from "../lib/amplify";
import { extractApiError } from "../lib/api_error";

const appUserStore = createDataStore<AppUser[] | undefined>();

export const useAdminUsers = appUserStore.useData;
export const setAdminUsers = appUserStore.setData;

export async function fetchAdminUsers(): Promise<void> {
  try {
    const { body } = await get({
      apiName: API_NAME,
      path: "/admin/list-users",
    }).response;

    const data = (await body.json()) as unknown as { users: AppUser[] };
    setAdminUsers(data.users);
  } catch (err) {
    throw new Error(await extractApiError(err));
  }
}

export async function assignUser(
  userId: string,
  customerId: string
): Promise<void> {
  try {
    await post({
      apiName: API_NAME,
      path: "/admin/assign-user",
      options: { body: { userId, customerId } },
    }).response;

    appUserStore.updateData((current) =>
      (current ?? []).map((user) =>
        user.userId === userId ? { ...user, customerId } : user
      )
    );
  } catch (err) {
    throw new Error(await extractApiError(err));
  }
}

export async function removeUser(userId: string): Promise<void> {
  try {
    await post({
      apiName: API_NAME,
      path: "/admin/remove-user",
      options: { body: { userId } },
    }).response;

    appUserStore.updateData((current) =>
      (current ?? []).map((user) =>
        user.userId === userId ? { ...user, customerId: undefined } : user
      )
    );
  } catch (err) {
    throw new Error(await extractApiError(err));
  }
}
